export function createNestedDashboardParameters(
  nestedDashboard,
  widgetNestedDashboardParameters,
  customParameters,
  twin
) {
  if (!nestedDashboard) {
    throw new Error('Nested dashboard not found');
  }

  if (!widgetNestedDashboardParameters) {
    throw new Error('Widget nested dashboard parameters not found');
  }

  if (!customParameters) {
    throw new Error('Custom parameters not found');
  }

  if (!twin) {
    throw new Error('Twin not found');
  }

  const nestedDashboardParameters = {
    ...nestedDashboard.value.customParameters,
  };

  Object.entries(widgetNestedDashboardParameters).forEach(([key, value]) => {
    if (value === '{{event.dtwin.id}}') {
      value = String(twin.id);
    }

    if (value === '{{event.dtwin.title}}') {
      value = twin.title;
    }

    Object.entries(customParameters).forEach(([customParameterKey, customParameterValue]) => {
      if (value === `{{dashboard.parameter.${customParameterKey}}}`) {
        value = customParameterValue;
      }
    });

    nestedDashboardParameters[key] = value;
  });

  return nestedDashboardParameters;
}
